import * as React from "react";

import ContractForm from "../../../components/Forms/LeaseContract/ContractForm/FlowForm";

export default () => {
  return <ContractForm />;
};
